import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/api/client";
import { ENDPOINTS } from "@/api/endpoints";
import { useAuth } from "./useAuth";
import type { CurrentUser } from "./currentUserTypes";

export type {
  CurrentUser,
  CurrentUserStoreAccess,
  UserRole,
} from "./currentUserTypes";

export const currentUserQueryOptions = {
  queryKey: ["currentUser"] as const,
  queryFn: () => apiFetch<CurrentUser>(ENDPOINTS.auth.me),
  staleTime: 5 * 60 * 1000,
};

export function useCurrentUser() {
  const { isAuthenticated } = useAuth();

  return useQuery({
    ...currentUserQueryOptions,
    enabled: isAuthenticated,
  });
}
